import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, IconButton, Typography,
} from "@mui/material";
import {Close} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

interface CancelConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const CancelConfirmDialog = ({open, onClose, onConfirm}: CancelConfirmDialogProps) => {
    const {t} = useTranslation("templates");
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {t('cancelConfirmDialog.title')}
                <IconButton size="small" onClick={onClose}><Close/></IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2">
                    {t('cancelConfirmDialog.message')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="outlined" onClick={onClose}>{t('cancelConfirmDialog.stay')}</Button>
                <Button variant="contained" color="accent" onClick={onConfirm}>
                    {t('cancelConfirmDialog.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelConfirmDialog;
